<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Cadastro"
  description="Verifique e altere seus dados pessoais e contatos">
</cbc-container>

@if (!isLoading) {
<div class="form-container" [class.is_mobile]="isMobile">
    <!-- Mostrar aviso quando CPF for obrigatório -->
    @if (isCpfRequired) {
    <div class="warning-box">
      <mat-icon color="warn">warning</mat-icon>
      <span>CPF é obrigatório para continuar usando o sistema</span>
    </div>
    }

    <form [formGroup]="userForm" data-cy="user-form" class="user-form">
      <div class="row">
          <mat-form-field appearance="outline" floatLabel="always" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" [email]="true" data-cy="email-input" />
          </mat-form-field>
      </div>
  
      <div class="row-2-col">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="firstName" data-cy="first-name-input" />
          </mat-form-field>
      
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Sobrenome</mat-label>
            <input matInput formControlName="lastName" data-cy="last-name-input" />
          </mat-form-field>
      </div>
  
      <div class="row-2-col">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>CPF *</mat-label>
            <input matInput formControlName="cpf" [showMaskTyped]="true" mask="000.000.000-00" data-cy="cpf-input"
              [class.required-field]="isCpfRequired" />
            @if (userForm.get('cpf')?.invalid && userForm.get('cpf')?.touched) {
            <mat-error data-cy="cpf-error">
              @if (userForm.get('cpf')?.errors?.['required']) {
              <span>CPF é obrigatório</span>
              }
              @if (userForm.get('cpf')?.errors?.['invalidCPF']) {
              <span>CPF inválido</span>
              }
              @if (userForm.get('cpf')?.errors?.['pattern']) {
              <span>CPF deve conter 11 dígitos</span>
              }
            </mat-error>
            }
          </mat-form-field>
      
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Número do telefone</mat-label>
            <input matInput formControlName="phoneNumber" [showMaskTyped]="true" mask="(00) 0000-0000||(00) 00000-0000"
              data-cy="phone-input" />
            @if (userForm.get('phoneNumber')?.invalid && userForm.get('phoneNumber')?.touched) {
            <mat-error data-cy="phone-error">
              Número de telefone inválido
            </mat-error>
            }
          </mat-form-field>
      </div>

      <!-- Campos informativos (read-only por natureza ou design) -->
      <div class="row-2-col">
        <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <input matInput [value]="(user?.status ?? '') | enumDescription" disabled />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Registro em</mat-label>
            <input matInput [value]="user?.registerDate | date : 'dd/MM/yyyy'" disabled />
        </mat-form-field>
      </div>

      <div class="info-row" style="margin-bottom: 20px; display: flex; align-items: center; gap: 10px;">
        <span class="info-label">Certificado de Hub Medical:</span>
        <div class="info-data">
            <img [src]="
                  user?.certifiedHubMedical
                    ? 'assets/icons/icon_certificado_concedido.svg'
                    : 'assets/icons/icon_certificado_ausente.svg'
                " [matTooltip]="
                  user?.certifiedHubMedical
                    ? 'Certificado Hub Medical'
                    : 'Não certificado'
                " width="24px" alt="" />
        </div>
      </div>

      @if (isCpfRequired) {
      <div class="form-section">
        <mat-checkbox formControlName="termsAccepted" #termscheckbox>
          Aceito os termos de uso e a política de privacidade
        </mat-checkbox>
        @if (userForm.get('termsAccepted')?.invalid && userForm.get('termsAccepted')?.touched) {
        <mat-error data-cy="terms-error">
          Você deve aceitar os termos de uso e a política de privacidade
        </mat-error>
        }
    
        <div class="buttons-wrap">
            <button matButton (click)="openTermsDialog()" data-cy="terms-button">Leia os termos de uso</button>
            <button matButton (click)="openPrivacyPolicyDialog()" data-cy="privacy-policy-button">Leia a política de
              privacidade</button>
        </div>
      </div>
      }
    </form>

    <div class="footerButtons">
      <!-- Botão Salvar sempre visível quando em modo edição -->
      @if (isEditMode) {
      <button (click)="saveUser()" mat-flat-button color="primary"
        [disabled]="!userForm.valid && (isCpfRequired? userForm.controls['termsAccepted'].value: true)"
        data-cy="save-button">
        Salvar
      </button>
      }
  
      <!-- Botão Editar só aparece quando NÃO está em modo edição -->
      @if (!isEditMode) {
      <button (click)="toggleEditMode()" mat-flat-button color="primary"
        data-cy="edit-button">
        Editar
      </button>
      }
  
      <!-- Botão Cancelar - só funciona se CPF não for obrigatório -->
      @if (isEditMode && !isCpfRequired) {
      <button mat-raised-button color="basic" (click)="toggleEditMode()"
        data-cy="cancel-button">
        Cancelar
      </button>
      }
  
      <!-- Botão Logout - aparece quando CPF for obrigatório -->
      @if (isCpfRequired) {
      <button mat-raised-button color="warn" (click)="logout()" data-cy="logout-button">
        <mat-icon>logout</mat-icon>
        Sair do sistema
      </button>
      }
    </div>
</div>
}